import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { useAuth } from "react-oidc-context";
import Info from './pages/Info';
import Data from './pages/Data';

function AppRoutes() {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <div style={{
        backgroundColor: '#1a1a1a',
        color: '#ffffff',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        Loading...
      </div>
    );
  }

  if (auth.error) {
    return (
      <div style={{
        backgroundColor: '#1a1a1a',
        color: '#ffffff',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        Oops... {auth.error.message}
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    auth.signinRedirect();
    return (
      <div style={{
        backgroundColor: '#1a1a1a',
        color: '#ffffff',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        Redirecting to login...
      </div>
    );
  }

  return (
    <div style={{
      backgroundColor: '#1a1a1a',
      minHeight: '100vh'
    }}>
      {/* Simple Navigation */}
      <nav style={{
        backgroundColor: '#000000',
        padding: '10px 20px',
        borderBottom: '1px solid #333',
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ display: 'flex', gap: '20px' }}>
            <Link 
              to="/" 
              style={{
                color: '#ffffff',
                textDecoration: 'none',
                padding: '8px 16px',
                borderRadius: '4px',
                transition: 'background-color 0.2s'
              }}
            >
              Info
            </Link>
            <Link 
              to="/data" 
              style={{
                color: '#ffffff',
                textDecoration: 'none',
                padding: '8px 16px',
                borderRadius: '4px',
                transition: 'background-color 0.2s'
              }}
            >
              Data
            </Link>
          </div>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <span style={{ color: '#cccccc', fontSize: '14px' }}>
              {auth.user?.profile?.email}
            </span>
            <button
              onClick={() => auth.signoutRedirect()}
              style={{
                backgroundColor: '#374151',
                color: '#ffffff',
                border: 'none',
                padding: '6px 12px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </nav>

      <Routes>
        <Route path="/" element={<Info />} />
        <Route path="/data" element={<Data />} />
      </Routes>
    </div>
  );
}

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;